'use client';

import { c as _c } from "react/compiler-runtime";
import { TreatmentCaseCard } from "@/features/home/ui";
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
import { useEffect, useRef } from "react";
interface TreatmentCaseListProps {
  treatmentCaseSummaryList: TreatmentCaseSummaryResponse[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  autoLoad?: boolean;
}
const noopFetchNext = () => {};
const TreatmentCaseList = t0 => {
  const $ = _c(12);
  const {
    treatmentCaseSummaryList,
    fetchNextPage: t1,
    hasNextPage: t2,
    autoLoad: t3
  } = t0;
  const fetchNextPage = t1 === undefined ? noopFetchNext : t1;
  const hasNextPage = t2 === undefined ? false : t2;
  const autoLoad = t3 === undefined ? true : t3;
  const loadMoreRef = useRef(null);
  let t4;
  let t5;
  if ($[0] !== autoLoad || $[1] !== fetchNextPage || $[2] !== hasNextPage) {
    t4 = () => {
      if (!autoLoad || !loadMoreRef.current || !hasNextPage) {
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [entry] = t6;
        if (entry.isIntersecting) {
          fetchNextPage();
        }
      }, {
        rootMargin: "200px"
      });
      observer.observe(loadMoreRef.current);
      return () => observer.disconnect();
    };
    t5 = [autoLoad, fetchNextPage, hasNextPage];
    $[0] = autoLoad;
    $[1] = fetchNextPage;
    $[2] = hasNextPage;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== treatmentCaseSummaryList) {
    t6 = treatmentCaseSummaryList.map(_temp);
    $[5] = treatmentCaseSummaryList;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== autoLoad) {
    t7 = autoLoad && <div ref={loadMoreRef} className="h-1" />;
    $[7] = autoLoad;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="flex flex-col">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default TreatmentCaseList;
function _temp(item, index) {
  return <TreatmentCaseCard key={`treatment-case-card-${index}`} item={item} index={index} />;
}